<template>
  <RevIllustration
    :alt="logo?.alt"
    class="!max-h-[120px] md:ml-0 object-contain"
    :class="{
      'object-bottom md:object-left-bottom': isHero,
      'object-left-bottom': !isHero,
      'hidden md:block': logo.heightMobile && logo.widthMobile,
    }"
    :height="dHeight"
    :src="logo?.src"
    :width="dWidth"
  />

  <RevIllustration
    v-if="logo.heightMobile && logo.widthMobile"
    :alt="logo?.alt"
    class="!max-h-[120px] object-contain md:hidden"
    :class="{
      'object-bottom': isHero,
      'object-left-bottom': !isHero,
    }"
    :height="mHeight"
    :src="logo?.srcMobile"
    :width="mWidth"
  />
</template>

<script setup lang="ts">
import type { Image } from '@backmarket/http-api/src/api-specs-content/models/image'
import { RevIllustration } from '@ds/components/Illustration'

const { isHero, logo } = defineProps<{ isHero: boolean; logo: Image }>()

// leave .svg files as x1 since retina scaling is not necessary
function getScaleFactor(src?: string) {
  return src?.endsWith('.svg') ? 1 : 0.5
}

const dScale = getScaleFactor(logo.src)
const mScale = getScaleFactor(logo.srcMobile)

const dHeight = logo.height * dScale
const dWidth = logo.width * dScale
const mHeight = (logo.heightMobile || logo.height) * mScale
const mWidth = (logo.widthMobile || logo.width) * mScale
</script>
